import { useEffect, useRef, useState } from 'react';


const Components = {};




Components[ 'status' ] = {

  loadContext: async ({ result }) => {
  },

  Input: ({ handle, meta, domain, context, updateDomain }) => {

    const RecordSection = require( '../../../components/view/RecordSection' ).default;

    const updateObjectField = (updateDomain, handle, fieldHandle, value) => {
      updateDomain((prevDomain) => {
        return {
          ...prevDomain,
          [handle]: {
            ...prevDomain[handle],
            [fieldHandle]: value,
          },
        };
      });
    };

    return (
      <RecordSection
        title={meta.label}
        className="record-related"
        actions={null}
      >

        <div className="">

          {meta.fields.map( ( field ) => {

            const Components = require( '../../../elements' ).default;

            const Component = Components.Meta.identity( field.field.value );

            const onFieldChange = (fieldHandle, value) => updateObjectField(updateDomain, handle, fieldHandle, value);
            
            return (
              <div key={field.handle} className="">
                <span className="kv-label">{field.label}</span>
                <div className="">
                  <Component.Input handle={field.handle} meta={field.field.meta} record={domain[handle]} context={{}} onFieldChange={onFieldChange} />
                </div>
              </div>
            );
          })}

        </div>

      </RecordSection>
    );
  },

  Output: ({ handle, meta, domain }) => {

    const RecordSection = require( '../../../components/view/RecordSection' ).default;

    return (
      <RecordSection
        title={meta.label}
        className="record-related"
        actions={null}
      >

        <div className="">

          {meta.fields.map( ( field ) => {

            const Components = require( '../../../elements' ).default;

            const Component = Components.Meta.identity( field.field.value );
            
            return (
              <div key={field.handle} className="">
                <span className="kv-label">{field.label}</span>
                <div className="">
                  <Component.Output handle={field.handle} meta={field.field.meta} record={domain[handle]} />
                </div>
              </div>
            );
          })}

        </div>

      </RecordSection>
    );
  }
};





Components[ 'selection' ] = {

  loadContext: async ({ result }) => {
  },

  Input: ({ handle, meta, domain, context, updateDomain }) => {

    const updateObjectField = (updateDomain, handle, fieldHandle, value) => {
      updateDomain((prevDomain) => {
        return {
          ...prevDomain,
          [handle]: {
            ...prevDomain[handle],
            [fieldHandle]: value,
          },
        };
      });
    };

    return (
      <div className="">
        <span className="kv-label">{meta.label}</span>
        <div className="">

          {meta.fields.map( ( field ) => {

            const Components = require( '../../../elements' ).default;

            const Component = Components.Meta.identity( field.field.value );

            const onFieldChange = (fieldHandle, value) => updateObjectField(updateDomain, handle, fieldHandle, value);
            
            return (
              <div key={field.handle} className="">
                <span className="kv-label">{field.label}</span>
                <div className="">
                  <Component.Input handle={field.handle} meta={field.field.meta} record={domain[handle]} context={{}} onFieldChange={onFieldChange} />
                </div>
              </div>
            );
          })}

        </div>
      </div>
    );
  },

  Output: ({ handle, meta, domain }) => {
    return (
      <div className="">
        <span className="kv-label">{meta.label}</span>
        <div className="">

          {meta.fields.map( ( field ) => {

            const Components = require( '../../../elements' ).default;

            const Component = Components.Meta.identity( field.field.value );
            
            return (
              <div key={field.handle} className="">
                <span className="kv-label">{field.label}</span>
                <div className="">
                  <Component.Output handle={field.handle} meta={field.field.meta} record={domain[handle]} />
                </div>
              </div>
            );
          })}

        </div>
      </div>
    );
  }
};





Components[ 'section' ] = {

  loadContext: async ({ result }) => {
  },

  Input: ({ handle, meta, domain, context, updateDomain }) => {

    const RecordSection = require( '../../../components/view/RecordSection' ).default;

    const updateObjectField = (updateDomain, handle, fieldHandle, value) => {
      updateDomain((prevDomain) => {
        return {
          ...prevDomain,
          [handle]: {
            ...prevDomain[handle],
            [fieldHandle]: value,
          },
        };
      });
    };

    return (
      <RecordSection
        title={meta.label}
        className="record-related"
        actions={null}
      >

        <div className="record-details-grid">

          {meta.fields.map( ( field ) => {

            const Components = require( '../../../elements' ).default;

            const Component = Components.Meta.identity( field.field.value );

            const onFieldChange = (fieldHandle, value) => updateObjectField(updateDomain, handle, fieldHandle, value);
            
            return (
              <div key={field.handle} className="">
                <span className="kv-label">{field.label}</span>
                <div className="">
                  <Component.Input handle={field.handle} meta={field.field.meta} record={domain[handle]} context={{}} onFieldChange={onFieldChange} />
                </div>
              </div>
            );
          })}

        </div>

      </RecordSection>
    );
  },

  Output: ({ handle, meta, domain }) => {

    const RecordSection = require( '../../../components/view/RecordSection' ).default;

    return (
      <RecordSection
        title={meta.label}
        className="record-related"
        actions={null}
      >

        <div className="record-details-grid">

          {meta.fields.map( ( field ) => {
    
            const Components = require( '../../../elements' ).default;

            const Component = Components.Meta.identity( field.field.value );
            
            return (
              <div key={field.handle} className="">
                <span className="kv-label">{field.label}</span>
                <div className="">
                  <Component.Output handle={field.handle} meta={field.field.meta} record={domain[handle]} />
                </div>
              </div>
            );
          })}

        </div>

      </RecordSection>
    );
  }
};





Components[ 'table' ] = {

  loadContext: async ({ result }) => {
  },

  Input: ({ handle, meta, domain, context, updateDomain }) => {

    const RecordSection = require( '../../../components/view/RecordSection' ).default;

    const rowKey = (row, index) => row?.id || row?.slug || row?.handle || row?.key || `row-${index}`;

    const defaultFieldValue = (field) => {
      const type = field?.field?.value || field?.value;

      if (type === 'boolean') return false;
      if (type === 'field') return { value: 'text', meta: {} };
      if (type === 'domain') return { value: 'children', meta: {} };
      if (type === 'select') return { value: '', label: '' };

      return '';
    };

    const createEmptyRow = (fields) => {
      const nextRow = {};

      fields.forEach((field) => {
        nextRow[field.handle] = defaultFieldValue(field);
      });

      return nextRow;
    };

    const updateArrayRowField = (updateDomain, handle, rowIndex, fieldHandle, value) => {
      updateDomain((prevDomain) => {
        return {
          ...prevDomain,
          [handle]: prevDomain[handle].map((row, index) => {
            if (index !== rowIndex) return row;

            return {
              ...row,
              [fieldHandle]: value,
            };
          }),
        };
      });
    };

    return (
      <RecordSection
        title={meta.label}
        className="record-related"
        actions={(
          <button
            className="button-secondary"
            type="button"
            onClick={() => {
              updateDomain((prevDomain) => {
                return {
                  ...prevDomain,
                  [handle]: [...prevDomain[handle], createEmptyRow(meta.fields)],
                };
              });
            }}
          >
            Add Row
          </button>
        )}
      >

        <table className="data-table">
          <thead>
            <tr>
              {meta.fields.map( ( field ) => (
                <th key={field.handle}>
                  {field.label}
                </th>
              ) )}
              <th key="actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            {domain[handle].map((row, rowIndex) => (
              <tr key={rowKey(row, rowIndex)}>

                {meta.fields.map( ( field ) => {

                  const Components = require( '../../../elements' ).default;

                  const Component = Components.Meta.identity( field.field.value );

                  const onFieldChange = (fieldHandle, value) => updateArrayRowField(updateDomain, handle, rowIndex, fieldHandle, value);
                  
                  return (
                    <td key={`${rowKey(row, rowIndex)}-${field.handle}`}>
                      <Component.Input handle={field.handle} meta={field.field.meta} record={row} context={{}} onFieldChange={onFieldChange} />
                    </td>
                  );
                })}

                <td key={`${rowKey(row, rowIndex)}-actions`}>
                  <button
                    className="button-danger"
                    type="button"
                    onClick={() => {
                      updateDomain((prevDomain) => {
                        return {
                          ...prevDomain,
                          [handle]: prevDomain[handle].filter((_, index) => index !== rowIndex),
                        };
                      });
                    }}
                  >
                    Remove
                  </button>
                </td>

              </tr>
            ))}
          </tbody>
        </table>

      </RecordSection>
    );
  },

  Output: ({ handle, meta, domain }) => {

    const RecordSection = require( '../../../components/view/RecordSection' ).default;

    const rowKey = (row, index) => row?.id || row?.slug || row?.handle || row?.key || `row-${index}`;

    return (
      <RecordSection
        title={meta.label}
        className="record-related"
        actions={null}
      >

        <table className="data-table">
          <thead>
            <tr>
              {meta.fields.map( ( field ) => (
                <th key={field.handle}>
                  {field.label}
                </th>
              ) )}
            </tr>
          </thead>
          <tbody>
            {domain[handle].map((row, rowIndex) => (
              <tr key={rowKey(row, rowIndex)}>

                {meta.fields.map( ( field ) => {

                  const Components = require( '../../../elements' ).default;

                  const Component = Components.Meta.identity( field.field.value );
                  
                  return (
                    <td key={`${rowKey(row, rowIndex)}-${field.handle}`}>
                      <Component.Output handle={field.handle} meta={field.field.meta} record={row} />
                    </td>
                  );
                })}

              </tr>
            ))}
          </tbody>
        </table>

      </RecordSection>
    );
  }
};



Components[ 'list' ] = {

  loadContext: async ({ result }) => {
  },

  Input: ({ handle, meta, domain, context, updateDomain }) => {

    const RecordSection = require( '../../../components/view/RecordSection' ).default;

    const rowKey = (row, index) => row?.id || row?.slug || row?.handle || row?.key || `row-${index}`;

    const defaultFieldValue = (field) => {
      const type = field?.field?.value || field?.value;

      if (type === 'boolean') return false;
      if (type === 'field') return { value: 'text', meta: {} };
      if (type === 'domain') return { value: 'children', meta: {} };
      if (type === 'select') return { value: '', label: '' };

      return '';
    };

    const createEmptyRow = (fields) => {
      const nextRow = {};

      fields.forEach((field) => {
        nextRow[field.handle] = defaultFieldValue(field);
      });

      return nextRow;
    };

    const updateArrayRowField = (updateDomain, handle, rowIndex, fieldHandle, value) => {
      updateDomain((prevDomain) => {
        return {
          ...prevDomain,
          [handle]: prevDomain[handle].map((row, index) => {
            if (index !== rowIndex) return row;

            return {
              ...row,
              [fieldHandle]: value,
            };
          }),
        };
      });
    };

    return (
      <RecordSection
        title={meta.label}
        className="record-related"
        actions={(
          <button
            className="button-secondary"
            type="button"
            onClick={() => {
              updateDomain((prevDomain) => {
                return {
                  ...prevDomain,
                  [handle]: [...prevDomain[handle], createEmptyRow(meta.fields)],
                };
              });
            }}
          >
            Add Row
          </button>
        )}
      >

        {domain[handle].map((row, rowIndex) => {

          const key = rowKey(row, rowIndex);

          return (
            <div key={key} className="record-details-grid" style={{ marginBottom: '1rem' }}>

              {(meta?.fields || [] ).map((field) => {

                const Components = require( '../../../elements' ).default;

                const Component = Components.Meta.identity( field.field.value );

                const onFieldChange = (fieldHandle, value) => updateArrayRowField(updateDomain, handle, rowIndex, fieldHandle, value);
                
                return (
                  <div key={`${key}-${field.handle}`}>
                    <span className="kv-label">{field.label}</span>
                    <div>
                      <Component.Input handle={field.handle} meta={field.field.meta} record={row} context={{}} onFieldChange={onFieldChange} />
                    </div>
                  </div>
                );
              })}

              <div>
                <button
                  className="button-danger"
                  type="button"
                  onClick={() => {
                    updateDomain((prevDomain) => {
                      return {
                        ...prevDomain,
                        [handle]: prevDomain[handle].filter((_, index) => index !== rowIndex),
                      };
                    });
                  }}
                >
                  Remove
                </button>
              </div>
            </div>
          );
        })}

      </RecordSection>
    );
  },

  Output: ({ handle, meta, domain }) => {

    const RecordSection = require( '../../../components/view/RecordSection' ).default;

    const rowKey = (row, index) => row?.id || row?.slug || row?.handle || row?.key || `row-${index}`;

    return (
      <RecordSection
        title={meta.label}
        className="record-related"
        actions={null}
      >

        {domain[handle].map((row, rowIndex) => {

          const key = rowKey(row, rowIndex);

          return (
            <div key={key} className="record-details-grid" style={{ marginBottom: '1rem' }}>

              {(meta?.fields || [] ).map((field) => {

                const Components = require( '../../../elements' ).default;

                const Component = Components.Meta.identity( field.field.value );
                
                return (
                  <div key={`${key}-${field.handle}`}>
                    <span className="kv-label">{field.label}</span>
                    <div>
                      <Component.Output handle={field.handle} meta={field.field.meta} record={row} />
                    </div>
                  </div>
                );
              })}

            </div>
          );
        })}

      </RecordSection>
    );
  }
};



Components[ 'reportParameters' ] = {

  loadContext: async ({ result }) => {
  },

  Input: ({ handle, meta, domain, context, updateDomain }) => {

    const nextReportHandle = (items, prefix) => {
      const handles = new Set(items.map((item) => item.handle));
      let index = 1;
      while (handles.has(`${prefix}${index}`)) index += 1;
      return `${prefix}${index}`;
    };

    const reportListText = (values) => values.map((value) => typeof value === 'object' ? value.value : value).join(', ');

    const ReportListInput = ({ values, onChange, ...props }) => {
      const [text, setText] = useState(() => reportListText(values));
      const lastValues = useRef(values);
      useEffect(() => {
        if (values !== lastValues.current) {
          setText(reportListText(values));
          lastValues.current = values;
        }
      }, [values]);
      return <input {...props} value={text} onChange={(event) => {
        const text = event.target.value;
        const parsed = text.split(',').map((value) => value.trim()).filter(Boolean);
        // Keep typed delimiters when the parent echoes the parsed values.
        lastValues.current = parsed;
        setText(text);
        onChange(parsed);
      }} />;
    };

    const form = domain[handle];
    const datasets = domain[meta.datasetsHandle] || [];
    const isReferenced = (parameter) => datasets.some((dataset) => (
      dataset.filters?.some((filter) => filter.value?.parameter === parameter.handle)
    ));

    const updateParameter = (index, changes) => {
      updateDomain((previous) => ({
        ...previous,
        [handle]: previous[handle].map((item, itemIndex) => itemIndex === index ? { ...item, ...changes } : item),
        ...(changes.handle !== undefined ? {
          [meta.datasetsHandle]: (previous[meta.datasetsHandle] || []).map((dataset) => ({
            ...dataset,
            filters: (dataset.filters || []).map((filter) => filter.value?.parameter === previous[handle][index].handle
              ? { ...filter, value: { parameter: changes.handle } }
              : filter),
          })),
        } : {}),
      }));
    };

    const addParameter = () => {
      updateDomain((previous) => ({
        ...previous,
        [handle]: [...previous[handle], {
          handle: nextReportHandle(previous[handle], 'parameter'),
          label: 'Parameter',
          type: 'text',
          required: false,
          defaultValue: '',
        }],
      }));
    };

    return (
      <>
        <section className="card" aria-label={meta.label}>
          <div className="row-between">
            <div><h2 className="section-title">{meta.label}</h2><p className="page-subtitle">Optional typed inputs that can drive dataset filters. Remove referencing criteria before removing a parameter.</p></div>
            <button type="button" className="button-secondary" disabled={form.length >= 20} onClick={addParameter}>Add parameter</button>
          </div>
          {form.map((parameter, index) => (
            <fieldset className="record-form-details-grid" key={index}>
              <legend>{parameter.label || parameter.handle}</legend>
              <label>
                <span className="kv-label">Handle</span>
                <input value={parameter.handle} onChange={(event) => updateParameter(index, { handle: event.target.value.replace(/[^a-zA-Z0-9_]/g, '') })} />
              </label>
              <label>
                <span className="kv-label">Label</span>
                <input value={parameter.label || ''} onChange={(event) => updateParameter(index, { label: event.target.value })} />
              </label>
              <label>
                <span className="kv-label">Type</span>
                <select value={parameter.type} onChange={(event) => {
                  updateParameter(index, {
                    type: event.target.value,
                    defaultValue: event.target.value === 'boolean' ? false : '',
                    ...(event.target.value === 'select' ? { options: parameter.options?.length ? parameter.options : ['Option 1'] } : {}),
                  });
                }} >
                  {['text', 'number', 'date', 'boolean', 'select'].map((type) => <option key={type} value={type}>{type}</option>)}
                </select>
              </label>
              {parameter.type === 'select' ? (
                <label><span className="kv-label">Options (comma-separated)</span><ReportListInput values={parameter.options} onChange={(options) => {
                  updateParameter(index, {
                    options,
                    defaultValue: options.includes(parameter.defaultValue) ? parameter.defaultValue : '',
                  });
                }} /></label>
              ) : null}
              {parameter.type === 'boolean' ? (
                <label><span className="kv-label">Default</span><input type="checkbox" checked={Boolean(parameter.defaultValue)} onChange={(event) => updateParameter(index, { defaultValue: event.target.checked })} /></label>
              ) : parameter.type === 'select' ? (
                <label><span className="kv-label">Default</span><select value={parameter.defaultValue ?? ''} onChange={(event) => updateParameter(index, { defaultValue: event.target.value })}>
                  <option value="">No default</option>
                  {(parameter.options || []).map((option) => {
                    const value = typeof option === 'string' ? option : option.value;
                    return <option key={value} value={value}>{typeof option === 'string' ? option : option.label || value}</option>;
                  })}
                </select></label>
              ) : (
                <label><span className="kv-label">Default</span><input type={parameter.type === 'number' ? 'number' : parameter.type === 'date' ? 'date' : 'text'} value={parameter.defaultValue ?? ''} onChange={(event) => updateParameter(index, {
                  defaultValue: parameter.type === 'number' && event.target.value !== '' ? Number(event.target.value) : event.target.value,
                })} /></label>
              )}
              <label><span className="kv-label">Required</span><input type="checkbox" checked={Boolean(parameter.required)} onChange={(event) => updateParameter(index, { required: event.target.checked })} /></label>
              <button type="button" className="button-danger" disabled={isReferenced(parameter)} title={isReferenced(parameter) ? 'Remove criteria referencing this parameter first.' : undefined} onClick={() => {
                updateDomain((previous) => ({
                  ...previous,
                  [handle]: previous[handle].filter((_, itemIndex) => itemIndex !== index),
                }));
              }}>Remove parameter</button>
            </fieldset>
          ))}
        </section>
      </>
    );
  },

  Output: ({ handle, meta, domain }) => {

    const parameters = domain[handle];
    const RecordSection = require('../../../components/view/RecordSection').default;
    return (
      <RecordSection title={meta.label}>
        {!parameters.length ? <p>No run parameters defined.</p> : (
          <ul>{parameters.map((parameter) => (
            <li key={parameter.handle}>
              <strong>{parameter.label || parameter.handle}</strong> ({parameter.handle}) — {parameter.type}
              {parameter.required ? ', required' : ', optional'}
              {parameter.defaultValue !== undefined && parameter.defaultValue !== '' ? `; default: ${String(parameter.defaultValue)}` : ''}
              {parameter.type === 'select' ? `; options: ${parameter.options.map((option) => typeof option === 'string' ? option : option.label || option.value).join(', ')}` : ''}
            </li>
          ))}</ul>
        )}
      </RecordSection>
    );
  }
};








Components[ 'reportDatasets' ] = {

  loadContext: async ({ result }) => {
    const http = require('../../../api/http').default;
    const { data } = await http.get('/reporting/catalog');
    if (!Array.isArray(data.sources)) throw new Error('The reporting catalog did not return data sources.');
    result.reportSources = data.sources;
  },

  Input: ({ handle, meta, domain, context, updateDomain }) => {

    const nextReportHandle = (items, prefix) => {
      const handles = new Set(items.map((item) => item.handle));
      let index = 1;
      while (handles.has(`${prefix}${index}`)) index += 1;
      return `${prefix}${index}`;
    };

    const reportListText = (values) => values.map((value) => typeof value === 'object' ? value.value : value).join(', ');

    const ReportListInput = ({ values, onChange, ...props }) => {
      const [text, setText] = useState(() => reportListText(values));
      const lastValues = useRef(values);
      useEffect(() => {
        if (values !== lastValues.current) {
          setText(reportListText(values));
          lastValues.current = values;
        }
      }, [values]);
      return <input {...props} value={text} onChange={(event) => {
        const text = event.target.value;
        const parsed = text.split(',').map((value) => value.trim()).filter(Boolean);
        // Keep typed delimiters when the parent echoes the parsed values.
        lastValues.current = parsed;
        setText(text);
        onChange(parsed);
      }} />;
    };

    const sources = context.reportSources;

    const form = domain[handle];
    const parameters = domain[meta.parametersHandle] || [];
    const layout = domain[meta.layoutHandle] || [];

    const updateDataset = (index, changes) => {
      updateDomain((previous) => {
        const current = previous[handle][index];
        return {
          ...previous,
          [handle]: previous[handle].map((item, itemIndex) => itemIndex === index ? { ...item, ...changes } : item),
          [meta.layoutHandle]: (previous[meta.layoutHandle] || []).map((component) => {
            if (component.dataset !== current.handle) return component;
            return {
              ...component,
              ...(changes.handle !== undefined ? { dataset: changes.handle } : {}),
              ...(changes.measures && component.field ? {
                field: changes.measures[(current.measures || []).findIndex((measure) => measure.handle === component.field)]?.handle || component.field,
              } : {}),
              ...(component.type === 'metric' && (changes.source || changes.mode) ? { field: undefined, operation: 'count' } : {}),
            };
          }),
        };
      });
    };

    const addDataset = () => {
      const source = sources[0];
      updateDomain((previous) => ({
        ...previous,
        [handle]: [...previous[handle], {
          handle: nextReportHandle(previous[handle], 'dataset'),
          label: source.label,
          source: source.handle,
          mode: 'rows',
          fields: source.fields.slice(0, 3).map((field) => field.handle),
          filters: [],
          limit: 100,
        }],
      }));
    };

    return (
      <>
        <section className="card" aria-label={meta.label}>
          <div className="row-between">
            <div><h2 className="section-title">{meta.label}</h2><p className="page-subtitle">Every active Model is a data source, including fields reached through its relations. Datasets return at most 500 rows. Remove referencing layout components before removing a dataset.</p></div>
            <button type="button" className="button-secondary" onClick={addDataset} disabled={!sources.length || form.length >= 8}>Add dataset</button>
          </div>
          {!sources.length ? <p className="error-text">No approved report data sources are available.</p> : null}
          {form.map((dataset, index) => {
            const source = sources.find((item) => item.handle === dataset.source);
            const fields = source?.fields || [];
            return (
              <fieldset className="record-related" key={index}>
                <legend>{dataset.label || dataset.handle}</legend>
                <div className="record-form-details-grid">
                  <label><span className="kv-label">Dataset handle</span><input value={dataset.handle} onChange={(event) => updateDataset(index, { handle: event.target.value.replace(/[^a-zA-Z0-9_]/g, '') })} /></label>
                  <label><span className="kv-label">Label</span><input value={dataset.label || ''} onChange={(event) => updateDataset(index, { label: event.target.value })} /></label>
                  <label>
                    <span className="kv-label">Data source</span>
                    <select value={dataset.source} onChange={(event) => {
                      const nextSource = sources.find((item) => item.handle === event.target.value);
                      updateDataset(index, {
                        source: event.target.value,
                        label: nextSource?.label || dataset.label,
                        filters: [],
                        orderBy: undefined,
                        ...(dataset.mode === 'aggregate'
                          ? {
                            fields: [],
                            groupBy: [],
                            measures: [{ handle: 'recordCount', label: 'Record count', field: '*', operation: 'count' }],
                          }
                          : { fields: nextSource?.fields.slice(0, 3).map((field) => field.handle) || [] }),
                      });
                    }}>
                      {sources.map((item) => <option key={item.handle} value={item.handle}>{item.label}{item.lifecycle === 'draft' ? ' (draft preview)' : ''}</option>)}
                    </select>
                  </label>
                  <label>
                    <span className="kv-label">Dataset mode</span>
                    <select value={dataset.mode || 'rows'} onChange={(event) => {
                      const mode = event.target.value;
                      const nextSource = sources.find((item) => item.handle === dataset.source);
                      updateDataset(index, mode === 'aggregate'
                        ? {
                          mode,
                          groupBy: [],
                          fields: [],
                          orderBy: undefined,
                          measures: [{ handle: 'recordCount', label: 'Record count', field: '*', operation: 'count' }],
                        }
                        : {
                          mode,
                          fields: dataset.fields?.length ? dataset.fields : nextSource?.fields.slice(0, 3).map((field) => field.handle) || [],
                          groupBy: undefined,
                          measures: undefined,
                        });
                    }}>
                      <option value="rows">Rows</option>
                      <option value="aggregate">Grouped aggregate</option>
                    </select>
                  </label>
                  <label><span className="kv-label">Maximum rows (1–500)</span><input type="number" min="1" max="500" value={dataset.limit ?? 100} onChange={(event) => updateDataset(index, { limit: Number(event.target.value) })} /></label>
                  {dataset.mode !== 'aggregate' ? (
                    <>
                      <label>
                        <span className="kv-label">Sort field</span>
                        <select value={dataset.orderBy?.field || ''} onChange={(event) => updateDataset(index, {
                          orderBy: event.target.value
                            ? { field: event.target.value, direction: dataset.orderBy?.direction || 'asc' }
                            : undefined,
                        })}>
                          <option value="">Default order</option>
                          {fields.map((field) => <option key={field.handle} value={field.handle}>{field.label}</option>)}
                        </select>
                      </label>
                      {dataset.orderBy?.field ? (
                        <label>
                          <span className="kv-label">Sort direction</span>
                          <select value={dataset.orderBy.direction || 'asc'} onChange={(event) => updateDataset(index, {
                            orderBy: { ...dataset.orderBy, direction: event.target.value },
                          })}>
                            <option value="asc">Ascending</option>
                            <option value="desc">Descending</option>
                          </select>
                        </label>
                      ) : null}
                    </>
                  ) : null}
                </div>
                <div>
                  <span className="kv-label">{dataset.mode === 'aggregate' ? 'Group by fields' : 'Fields'}</span>
                  <div className="action-cluster">
                    {fields.map((field) => (
                      <label key={field.handle}>
                        <input
                          type="checkbox"
                          checked={(dataset.mode === 'aggregate' ? dataset.groupBy || [] : dataset.fields || []).some((item) => (typeof item === 'string' ? item : item.field) === field.handle)}
                          onChange={(event) => {
                            const selected = dataset.mode === 'aggregate' ? dataset.groupBy || [] : dataset.fields || [];
                            const next = event.target.checked
                              ? [...selected, field.handle]
                              : selected.filter((item) => (typeof item === 'string' ? item : item.field) !== field.handle);
                            updateDataset(index, dataset.mode === 'aggregate' ? { groupBy: next } : { fields: next });
                          }}
                        />
                        {field.label}
                      </label>
                    ))}
                  </div>
                </div>
                {dataset.mode === 'aggregate' ? (
                  <div className="record-form-details-grid">
                    <label>
                      <span className="kv-label">Measure handle</span>
                      <input value={dataset.measures?.[0]?.handle || ''} onChange={(event) => updateDataset(index, {
                        measures: [{ ...(dataset.measures?.[0] || {}), handle: event.target.value.replace(/[^a-zA-Z0-9_]/g, '') }, ...(dataset.measures || []).slice(1)],
                      })} />
                    </label>
                    <label>
                      <span className="kv-label">Measure label</span>
                      <input value={dataset.measures?.[0]?.label || ''} onChange={(event) => updateDataset(index, {
                        measures: [{ ...(dataset.measures?.[0] || {}), label: event.target.value }, ...(dataset.measures || []).slice(1)],
                      })} />
                    </label>
                    <label>
                      <span className="kv-label">Operation</span>
                      <select value={dataset.measures?.[0]?.operation || 'count'} onChange={(event) => updateDataset(index, {
                        measures: [{ ...(dataset.measures?.[0] || {}), operation: event.target.value, field: event.target.value === 'count' ? '*' : fields.find((field) => ['INTEGER', 'BIGINT', 'FLOAT', 'DOUBLE', 'REAL', 'DECIMAL'].includes(field.type))?.handle || '' }, ...(dataset.measures || []).slice(1)],
                      })}>
                        {['count', 'sum', 'average', 'min', 'max'].map((operation) => <option key={operation} value={operation}>{operation}</option>)}
                      </select>
                    </label>
                    {dataset.measures?.[0]?.operation !== 'count' ? (
                      <label>
                        <span className="kv-label">Numeric measure field</span>
                        <select value={dataset.measures?.[0]?.field || ''} onChange={(event) => updateDataset(index, {
                          measures: [{ ...(dataset.measures?.[0] || {}), field: event.target.value }, ...(dataset.measures || []).slice(1)],
                        })}>
                          <option value="">Choose a field</option>
                          {fields.filter((field) => ['INTEGER', 'BIGINT', 'FLOAT', 'DOUBLE', 'REAL', 'DECIMAL'].includes(field.type))
                            .map((field) => <option key={field.handle} value={field.handle}>{field.label}</option>)}
                        </select>
                      </label>
                    ) : null}
                  </div>
                ) : null}
                <div className="stack-sm">
                  <span className="kv-label">Criteria</span>
                  {(dataset.filters || []).map((filter, filterIndex) => (
                    <div className="action-cluster" key={`filter-${filterIndex}`}>
                      <select aria-label="Filter field" value={filter.field} onChange={(event) => {
                        const filters = [...dataset.filters];
                        const fieldType = fields.find((field) => field.handle === event.target.value)?.type;
                        const isText = ['STRING', 'TEXT'].includes(fieldType);
                        filters[filterIndex] = {
                          ...filter,
                          field: event.target.value,
                          operator: filter.operator === 'contains' && !isText ? 'eq' : filter.operator,
                        };
                        updateDataset(index, { filters });
                      }}>
                        {fields.map((field) => <option key={field.handle} value={field.handle}>{field.label}</option>)}
                      </select>
                      <select aria-label="Filter operator" value={filter.operator} onChange={(event) => {
                        const filters = [...dataset.filters];
                        const operator = event.target.value;
                        filters[filterIndex] = {
                          ...filter,
                          operator,
                          value: filter.value?.parameter ? filter.value
                            : operator === 'in' ? (Array.isArray(filter.value) ? filter.value : [filter.value])
                              : Array.isArray(filter.value) ? filter.value[0] || '' : filter.value,
                        };
                        updateDataset(index, { filters });
                      }}>
                        {[
                          'eq', 'ne', 'gt', 'gte', 'lt', 'lte', 'in',
                          ...(fields.find((field) => field.handle === filter.field)?.type === 'STRING'
                            || fields.find((field) => field.handle === filter.field)?.type === 'TEXT'
                            ? ['contains']
                            : []),
                        ].map((operator) => <option key={operator} value={operator}>{operator}</option>)}
                      </select>
                      <select aria-label="Filter value type" value={filter.value?.parameter ? 'parameter' : 'literal'} onChange={(event) => {
                        const filters = [...dataset.filters];
                        filters[filterIndex] = {
                          ...filter,
                          value: event.target.value === 'parameter'
                            ? { parameter: parameters[0]?.handle || '' }
                            : filter.operator === 'in' ? [] : '',
                        };
                        updateDataset(index, { filters });
                      }}>
                        <option value="literal">Literal</option>
                        <option value="parameter" disabled={!parameters.length}>Run parameter</option>
                      </select>
                      {filter.value?.parameter ? (
                        <select aria-label="Run parameter" value={filter.value.parameter} onChange={(event) => {
                          const filters = [...dataset.filters];
                          filters[filterIndex] = { ...filter, value: { parameter: event.target.value } };
                          updateDataset(index, { filters });
                        }}>
                          {parameters.map((parameter) => <option key={parameter.handle} value={parameter.handle}>{parameter.label || parameter.handle}</option>)}
                        </select>
                      ) : filter.operator === 'in' ? (
                        <ReportListInput aria-label="Filter value" values={filter.value} onChange={(value) => {
                          const filters = [...dataset.filters];
                          filters[filterIndex] = { ...filter, value };
                          updateDataset(index, { filters });
                        }} />
                      ) : (
                        <input aria-label="Filter value" value={filter.value ?? ''} onChange={(event) => {
                          const filters = [...dataset.filters];
                          filters[filterIndex] = { ...filter, value: event.target.value };
                          updateDataset(index, { filters });
                        }} />
                      )}
                      <button type="button" className="button-danger" onClick={() => updateDataset(index, { filters: dataset.filters.filter((_, itemIndex) => itemIndex !== filterIndex) })}>Remove</button>
                    </div>
                  ))}
                  <button type="button" className="button-secondary" disabled={!fields.length || (dataset.filters || []).length >= 20} onClick={() => updateDataset(index, {
                    filters: [...(dataset.filters || []), { field: fields[0].handle, operator: 'eq', value: '' }],
                  })}>Add criterion</button>
                </div>
                <button type="button" className="button-danger" disabled={layout.some((component) => component.dataset === dataset.handle)} title={layout.some((component) => component.dataset === dataset.handle) ? 'Remove layout components referencing this dataset first.' : undefined} onClick={() => updateDomain((previous) => ({
                  ...previous,
                  [handle]: previous[handle].filter((_, itemIndex) => itemIndex !== index),
                }))}>Remove dataset</button>
              </fieldset>
            );
          })}
        </section>
      </>
    );
  },

  Output: ({ handle, meta, domain }) => {
    const RecordSection = require('../../../components/view/RecordSection').default;
    const datasets = domain[handle];
    return (
      <RecordSection title={meta.label}>
        {!datasets.length ? <p>No datasets defined.</p> : datasets.map((dataset) => (
          <div className="record-related" key={dataset.handle}>
            <h4>{dataset.label || dataset.handle}</h4>
            <p>Handle: {dataset.handle} · Source: {dataset.source} · Mode: {dataset.mode || 'rows'} · Maximum rows: {dataset.limit ?? 100}</p>
            {dataset.mode === 'aggregate' ? (
              <>
                <p>Group by: {dataset.groupBy?.join(', ') || 'All records'}</p>
                <ul>{dataset.measures.map((measure) => (
                  <li key={measure.handle}>{measure.label || measure.handle}: {measure.operation}({measure.field})</li>
                ))}</ul>
              </>
            ) : (
              <p>Fields: {dataset.fields.map((field) => typeof field === 'string' ? field : `${field.label || field.field} (${field.field})`).join(', ')}</p>
            )}
            {dataset.orderBy ? <p>Sort: {dataset.orderBy.field} ({dataset.orderBy.direction})</p> : null}
            {dataset.filters?.length ? (
              <ul>{dataset.filters.map((filter, index) => (
                <li key={index}>{filter.field} {filter.operator} {filter.value?.parameter ? `parameter: ${filter.value.parameter}` : JSON.stringify(filter.value)}</li>
              ))}</ul>
            ) : <p>No criteria.</p>}
          </div>
        ))}
      </RecordSection>
    );
  }
};





Components[ 'reportLayout' ] = {

  loadContext: async ({ result }) => {
  },

  Input: ({ handle, meta, domain, context, updateDomain }) => {

    const nextReportHandle = (items, prefix) => {
      const handles = new Set(items.map((item) => item.handle));
      let index = 1;
      while (handles.has(`${prefix}${index}`)) index += 1;
      return `${prefix}${index}`;
    };

    const sources = context.reportSources;

    const availableDatasets = domain[meta.datasetsHandle] || [];

    const form = domain[handle];

    const updateComponent = (index, changes) => {
      updateDomain((previous) => ({
        ...previous,
        [handle]: previous[handle].map((component, componentIndex) => componentIndex === index ? { ...component, ...changes } : component),
      }));
    };

    const moveComponent = (index, direction) => {
      updateDomain((previous) => {
        const components = [...previous[handle]];
        const nextIndex = index + direction;
        [components[index], components[nextIndex]] = [components[nextIndex], components[index]];
        return { ...previous, [handle]: components };
      });
    };

    const addComponent = (type) => {
      updateDomain((previous) => ({
        ...previous,
        [handle]: [...previous[handle], {
          handle: nextReportHandle(previous[handle], 'component'),
          type,
          title: type === 'table' ? 'Data table' : type === 'metric' ? 'Metric' : type === 'heading' ? 'Heading' : 'Text',
          ...(['table', 'metric'].includes(type) ? { dataset: availableDatasets[0].handle } : {}),
          ...(type === 'metric' ? { operation: 'count' } : {}),
        }],
      }));
    };

    return (
      <>
        <section className="card" aria-label={meta.label}>
          <div className="row-between">
            <div><h2 className="section-title">{meta.label}</h2><p className="page-subtitle">Arrange headings, explanatory text, metric cards and tables.</p></div>
            <div className="action-cluster">
              {['heading', 'text', 'metric', 'table'].map((type) => (
                <button
                  type="button"
                  className="button-secondary"
                  key={type}
                  disabled={form.length >= 30 || (['metric', 'table'].includes(type) && !availableDatasets.length)}
                  onClick={() => addComponent(type)}
                >
                  Add {type}
                </button>
              ))}
            </div>
          </div>
          {form.map((component, index) => (
            <fieldset className="record-form-details-grid" key={index}>
              <legend>{component.title || component.handle}</legend>
              <label><span className="kv-label">Component handle</span><input value={component.handle} onChange={(event) => updateComponent(index, { handle: event.target.value.replace(/[^a-zA-Z0-9_]/g, '') })} /></label>
              <label><span className="kv-label">Component</span><select value={component.type} onChange={(event) => {
                const type = event.target.value;
                updateComponent(index, {
                  type,
                  dataset: ['table', 'metric'].includes(type) ? component.dataset || availableDatasets[0]?.handle : undefined,
                  field: undefined,
                  operation: type === 'metric' ? 'count' : undefined,
                });
              }}>
                {['heading', 'text', 'metric', 'table'].map((type) => <option key={type} value={type} disabled={['table', 'metric'].includes(type) && !availableDatasets.length}>{type}</option>)}
              </select></label>
              <label><span className="kv-label">Title / text</span><input value={component.title || ''} onChange={(event) => updateComponent(index, { title: event.target.value })} /></label>
              {['table', 'metric'].includes(component.type) ? (
                <label><span className="kv-label">Dataset</span><select value={component.dataset || ''} onChange={(event) => updateComponent(index, { dataset: event.target.value, field: undefined, operation: component.type === 'metric' ? 'count' : undefined })}>
                  {availableDatasets.map((dataset) => <option key={dataset.handle} value={dataset.handle}>{dataset.label || dataset.handle}</option>)}
                </select></label>
              ) : null}
              {component.type === 'metric' ? (
                <>
                  {availableDatasets.find((dataset) => dataset.handle === component.dataset)?.mode === 'aggregate' ? (
                    <label><span className="kv-label">Aggregate measure</span><select value={component.field || ''} onChange={(event) => updateComponent(index, {
                      field: event.target.value || undefined,
                      operation: event.target.value ? 'sum' : 'count',
                    })}>
                      <option value="">Count result groups</option>
                      {(availableDatasets.find((dataset) => dataset.handle === component.dataset)?.measures || []).map((measure) => <option key={measure.handle} value={measure.handle}>{measure.label || measure.handle}</option>)}
                    </select></label>
                  ) : (
                    <label><span className="kv-label">Calculation</span><select value={component.operation || 'count'} onChange={(event) => updateComponent(index, { operation: event.target.value, field: undefined })}>
                      <option value="count">Count rows</option>
                      <option value="sum">Sum a numeric field</option>
                    </select></label>
                  )}
                  {component.operation === 'sum' && availableDatasets.find((dataset) => dataset.handle === component.dataset)?.mode !== 'aggregate' ? (
                    <label><span className="kv-label">Numeric field</span><select value={component.field || ''} onChange={(event) => updateComponent(index, { field: event.target.value || undefined })}>
                      <option value="">Choose a field</option>
                      {(availableDatasets.find((dataset) => dataset.handle === component.dataset)?.fields || []).map((field) => {
                        const handle = typeof field === 'string' ? field : field.field;
                        const selectedDataset = availableDatasets.find((dataset) => dataset.handle === component.dataset);
                        const fieldInfo = sources.find((source) => source.handle === selectedDataset?.source)?.fields.find((item) => item.handle === handle);
                        if (!['INTEGER', 'BIGINT', 'FLOAT', 'DOUBLE', 'REAL', 'DECIMAL'].includes(fieldInfo?.type)) return null;
                        return <option key={handle} value={handle}>{fieldInfo.label}</option>;
                      })}
                    </select></label>
                  ) : null}
                </>
              ) : null}
              <button type="button" className="button-danger" onClick={() => updateDomain((previous) => ({
                ...previous,
                [handle]: previous[handle].filter((_, itemIndex) => itemIndex !== index),
              }))}>Remove component</button>
              <div className="action-cluster">
                <button type="button" className="button-secondary" disabled={index === 0} onClick={() => moveComponent(index, -1)}>Move up</button>
                <button type="button" className="button-secondary" disabled={index === form.length - 1} onClick={() => moveComponent(index, 1)}>Move down</button>
              </div>
            </fieldset>
          ))}
        </section>
      </>
    );
  },

  Output: ({ handle, meta, domain }) => {
    const RecordSection = require('../../../components/view/RecordSection').default;
    const components = domain[handle];
    return (
      <RecordSection title={meta.label}>
        {!components.length ? <p>No layout components defined.</p> : (
          <ol>{components.map((component) => (
            <li key={component.handle}>
              <strong>{component.title || component.handle}</strong> ({component.handle}) — {component.type}
              {component.dataset ? `; dataset: ${component.dataset}` : ''}
              {component.type === 'metric' ? `; ${component.operation || 'count'}${component.field ? `(${component.field})` : ' rows/groups'}` : ''}
            </li>
          ))}</ol>
        )}
      </RecordSection>
    );
  }
};




export default Components;
